const menuItems = [
    {id: 1, value:'Головна', href: '/main', icon: 'home'},
    {id: 2, value:'Про мене', href: '/aboutme', icon: 'star'},
    {id: 3, value:'Публікації', href: '/posts', icon: 'favorite'},
    {id: 4, value:'Послуги', href: '/services', icon: 'token'},
    {id: 5, value:'F. A. Q.', href: '/faq', icon: 'psychology'},
    {id: 6, value:'Контакти', href: '/contacts', icon: 'mail'}
  ];

  export default menuItems;